var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.25,
    height: 15.75,
    viewBox: "0 0 20.25 15.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875-14.625a2.251,2.251,0,0,1,2.25,2.25v1.125h-20.25v-1.125a2.25,2.25,0,0,1,2.25-2.25Zm2.25,13.5a2.252,2.252,0,0,1-2.25,2.25H-7.875a2.251,2.251,0,0,1-2.25-2.25v-6.75h20.25ZM-6.187-3.375a.564.564,0,0,0-.562.563.564.564,0,0,0,.563.563h2.25a.564.564,0,0,0,.563-.562.564.564,0,0,0-.562-.562Zm4.5,1.125h4.5a.564.564,0,0,0,.563-.562.564.564,0,0,0-.562-.562h-4.5a.564.564,0,0,0-.562.563A.564.564,0,0,0-1.687-2.25Z",
    transform: "translate(10.125 14.625)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/credit-card-icon.d4b26e6c2484703f8bbf92284f8c2250.svg";
export { ForwardRef as ReactComponent };